<div class="flex flex-col flex-wrap w-full items-center justify-center py-1">
  <div style="width: 128px; height: 128px;"
       class="text-center self-center h-9 w-9 m-2 relative p-2">
    <img style="min-height: 128px;" [src]="iconUrl"/>
  </div>
  <div class="text-center m-2 self-center">
    <dx-button
      stylingMode="text"
      text="Changer"
      type="normal"
      (onClick)="changeIconImg($event)">
    </dx-button>
  </div>
</div>
<input class="hidden" (change)="onIconUpload($event)" type="file" accept="image/*" #iconBtn>
